import React from "react";
import "../../styles/Modals.css";

const DeleteReservationModal = ({ itemName, itemDate, onClose, onConfirm }) => {
    return (
        <div
          className="modal-backdrop"
          onClick={(e) => {
            if (e.target.classList.contains("modal-backdrop")) {
              onClose();
            }
          }}
        >
            <div className="modal-container">
                <h2>Delete Reservation</h2>
                <p>Are you sure you want to delete the reservation for <strong>{itemName}</strong> on <strong>{itemDate}</strong>?</p>
                <p>This action <strong>cannot</strong> be undone.</p>

                <div className="modal-actions">
                    <button className="btn-cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="btn-delete" onClick={onConfirm}>
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteReservationModal;
